<template>
  <div class="calendar-event-date">
    <ResponsiveContent>
      <template #mobile>
        <div class="mobile">
          <CalendarEventDateChooser />
        </div>
      </template>
      <template #desktop>
        <div class="desktop d-md-flex">
          <CalendarEventDateChooser />
        </div>
      </template>
    </ResponsiveContent>
  </div>
</template>

<script lang="ts">
import { ResponsiveContent } from '@bd/components'
import { defineComponent } from 'vue'
import CalendarEventDateChooser from './CalendarEventDateChooser.vue'

export default defineComponent({
  components: {
    ResponsiveContent,
    CalendarEventDateChooser,
  },
})
</script>

<style lang="scss" scoped></style>
